import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Beranda from './pages/Beranda';
import About from './pages/About';
import PaketPerjalanan from './pages/PaketPerjalanan';
import Artikel from './pages/Artikel';
import Contact from './pages/Contact';

export default function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Beranda />} />
        <Route path="/about" element={<About />} />
        <Route path="/paketperjalanan" element={<PaketPerjalanan />} />
        <Route path="/artikel" element={<Artikel />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}
